import TextField from "@/components/site-builder/TextField";
import { type StatisticsBlock } from "../types";
import AnimatedStatistic from "./AnimatedStatistic";
import s from "./BaseStatisticBlock.module.scss";

interface BaseStatisticBlockProps {
  block: StatisticsBlock;
}

export default function BaseStatisticBlock(props: BaseStatisticBlockProps) {
  const { block } = props;
  const { statistic, description, animated } = block;

  return (
    <div className={s.wrapper}>
      {animated ? (
        <AnimatedStatistic block={block} />
      ) : (
        <TextField type="header-h2" field={statistic} />
      )}
      <TextField type="text-large" field={description} />
    </div>
  );
}
